import { getCookie } from '../../helpers/helpers';

const storageMap = [
    { name: 'metrics_pcsid', fieldName: 'pc_pcsid', type: 'cookie' },
    { name: '_ncg_id_', fieldName: 'ad_ppid', type: 'cookie' }
];

/**
 * Resolve and store values from cookies or local storage on window.utag_data so that downstream
 * consumers can access them prior to utag loading.
 */
export default function setUserDataFromStorage () {
    if (!window.utag_data) {
        return;
    }

    for (const { name, fieldName, type } of storageMap) {
        let value;

        if (type === 'localstorage') {
            value = localStorage.getItem(name);
        } else {
            value = getCookie(name);
        }

        console.debug(`[speedcurve] utag_data Resolved ${fieldName} from ${type} ${name}:`, value);

        if (value && value !== 'na') {
            window.utag_data[fieldName] = decodeURIComponent(value);
        }
    }
}
